precision highp float;

attribute vec4 aVertexPosition;

uniform mat4 uModelViewMatrix;
uniform mat4 uProjectionMatrix;

uniform float iTime;
uniform float uScroll;

varying vec4 vPosition;

varying vec2 uv;

void main() {
    gl_Position = aVertexPosition;

    gl_Position = uProjectionMatrix * uModelViewMatrix * aVertexPosition;
    vPosition = gl_Position;
    uv = aVertexPosition.xy;
}